ion-card-content {
  display: block;
  position: relative;
}

.card-content-md {
  -webkit-padding-start: 16px;
  padding-inline-start: 16px;
  -webkit-padding-end: 16px;
  padding-inline-end: 16px;
  padding-top: 13px;
  padding-bottom: 13px;
  font-size: 14px;
  line-height: 1.5;
}
.card-content-md h1 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 2px;
  font-size: 24px;
  font-weight: normal;
}
.card-content-md h2 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 16px;
  font-weight: normal;
}
.card-content-md h3,
.card-content-md h4,
.card-content-md h5,
.card-content-md h6 {
  margin-left: 0;
  margin-right: 0;
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 14px;
  font-weight: normal;
}
.card-content-md p {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 2px;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.5;
}

ion-card-header + .card-content-md {
  padding-top: 0;
}